module.exports = __webpack_public_path__ + "static/media/6.dd720586.jpg";